var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

        var initializeBlock = function ($block) {

        // var offsetLeft;
        // function sliderOffsetLeft() {
        //     if($('.block-career').length > 0){
        //         if ($(window).width() > 991) {
        //             var offsetLeft = $('.block-career .reference-column').offset().left;
        //             $('.block-career .slider-outer .element').css('left', offsetLeft);
        //             $('.block-career .slider-gradient').css('width', offsetLeft);
        //         }else {
        //             $('.block-career .slider-outer').css('left', '0');
        //         }
        //     }
        // }

        // init Swiper:
        const swiperCareer = new Swiper('.career-slider', {
            // Optional parameters
            direction: 'horizontal',
            slidesPerView: 1,
            loop: false,
            navigation: {
                nextEl: '.career-custom-swiper-button-next',
                prevEl: '.career-custom-swiper-button-prev',
            },
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 640px
                992: {
                    loop:false,
                    slidesPerView: 3
                }
            }
        });

            swiperCareer.on('slideChange', function (e) {
                console.log('length: ',this.slides.length);
                var indexFinal = this.realIndex;
                console.log('slide index: ',indexFinal);
                if(indexFinal == 0){
                    console.log('state1');
                    $('.career-custom-swiper-button-prev').addClass('inactive');
                    $('.career-custom-swiper-button-next').removeClass('inactive');
                }else if(indexFinal == this.slides.length - 3){
                    console.log('state2');
                    $('.career-custom-swiper-button-prev').removeClass('inactive');
                    $('.career-custom-swiper-button-next').addClass('inactive');
                }else {
                    $('.career-custom-swiper-button-next').removeClass('inactive');
                    $('.career-custom-swiper-button-prev').removeClass('inactive');
                }
            });

        // functions
        // sliderOffsetLeft();
        // jQuery(window).on('resize', function () {
        // 	setTimeout(function () {
        //       sliderOffsetLeft();
        // 	}, 100);
        // });
    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=career', initializeBlock);
    }
});
